export const normalizePath = (path: string | null) => _trimEnd(path?.toLowerCase(), '/') || '/'
